module.exports = __webpack_public_path__ + "img/Missing Stone.d7bc4c09.png";